import Icon from '../components/Icon.vue'

Icon.register({
  shapes: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 320V480C512 497.7 497.7 512 480 512H320C302.3 512 288 497.7 288 480V320C288 302.3 302.3 288 320 288H480C497.7 288 512 302.3 512 320zM128 256C57.3 256 0 313.3 0 384S57.3 512 128 512 256 454.7 256 384 198.7 256 128 256zM479 224C504.4 224 520.2 197.3 507.5 176L412.5 16C399.8-5.3 368.2-5.3 355.5 16L260.5 176C247.8 197.3 263.6 224 289 224H479z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shapes.js
// module id = HNmk
// module chunks = 144